<template>
  <div class="metal_changed_pic">
    <img :src="imageUrl" />
    <div class="metal-text">
      <div class="templeName">
        <div class="textContainer">
          <span class="text" v-html="textInfo[0].textContent"></span>
        </div>
      </div>
      <div class="godName text-two">
        <div class="textContainer">
          <span class="text" v-html="textInfo[1].textContent"></span>
        </div>
      </div>
      <div class="gift">
        <div class="textContainer">
          <span class="text" v-html="textInfo[2].textContent"></span>
        </div>
      </div>
      <div class="respect">
        <div class="textContainer">
          <slot name="respect" :text="textInfo[3].textContent">
            <span class="text" v-html="textInfo[3].textContent"></span>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * BaseCustomizeMetal.vue 為以金牌 Ａ 為基礎建立的元件
 * 其他金牌元件皆以此元件為基礎建立
 * 新增金牌相關說明可參考 src/docs/addTraditionalMetal.md
 *
 * @props
 * componentCode: String，金牌元件代碼，預設為 A
 * useNotReverse: Boolean，是否使用不反轉文字的邏輯，預設為 false，因金牌原始設計是反轉的
 * useGodNameVerticalText: Boolean，是否使用神明名稱直式文字，預設為 false，目前僅 godName 可使用直式文字
 */
import commonMixin from "@/commonMixin.js";
export default {
  name: "BaseCustomizeMetal",
  mixins: [commonMixin],
  props: {
    componentCode: {
      type: String,
      default: "A",
    },
    useNotReverse: {
      type: Boolean,
      default: false,
    },
    useGodNameVerticalText: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.calcEmFontsizeBase();
    if (this.useGodNameVerticalText) {
      this.verticalCalcEmFontsizeBase();
    }
    this.controlWrapMethod()(0, this.customTextTempleName);
    this.controlFontsize(0, this.customTextTempleName);
    this.handleGodName();
    this.controlWrapMethod()(2, this.customTextGift);
    this.controlFontsize(2, this.customTextGift);
    this.controlWrapMethod()(3, this.customTextRespect);
    this.controlFontsize(3, this.customTextRespect);
  },
  data() {
    return {
      textInfo: [
        {
          name: "templeName",
          lineLimit: this.$store.getters.textSettingByComponentCode(
            this.componentCode
          ).templeName.lineLimit,
          textLimit: this.$store.getters.textSettingByComponentCode(
            this.componentCode
          ).templeName.textLimit,
          maxFontsize: this.$store.getters.textSettingByComponentCode(
            this.componentCode
          ).templeName.maxFontsize,
          emFontsize: "",
          changeFontsizeLimit: "",
          textContent: "",
        },
        {
          name: "godName",
          lineLimit: this.$store.getters.textSettingByComponentCode(
            this.componentCode
          ).godName.lineLimit,
          textLimit: this.$store.getters.textSettingByComponentCode(
            this.componentCode
          ).godName.textLimit,
          maxFontsize: this.$store.getters.textSettingByComponentCode(
            this.componentCode
          ).godName.maxFontsize,
          emFontsize: "",
          changeFontsizeLimit: "",
          textContent: "",
        },
        {
          name: "gift",
          lineLimit: this.$store.getters.textSettingByComponentCode(
            this.componentCode
          ).gift.lineLimit,
          textLimit: this.$store.getters.textSettingByComponentCode(
            this.componentCode
          ).gift.textLimit,
          maxFontsize: this.$store.getters.textSettingByComponentCode(
            this.componentCode
          ).gift.maxFontsize,
          emFontsize: "",
          changeFontsizeLimit: "",
          textContent: "",
        },
        {
          name: "respect",
          lineLimit: 1,
          textLimit: 2,
          maxFontsize: 20,
          emFontsize: "",
          changeFontsizeLimit: "",
          textContent: "",
        },
      ],
    };
  },
  watch: {
    customTextTempleName() {
      this.controlWrapMethod()(0, this.customTextTempleName);
      this.controlFontsize(0, this.customTextTempleName);
    },
    customTextGodName() {
      this.handleGodName();
    },
    customTextGift() {
      this.controlWrapMethod()(2, this.customTextGift);
      this.controlFontsize(2, this.customTextGift);
    },
    customTextRespect() {
      this.controlWrapMethod()(3, this.customTextRespect);
      this.controlFontsize(3, this.customTextRespect);
    },
  },
  computed: {
    imageUrl() {
      const metalData = this.$store.getters.customizeMetalDataByComponentCode(
        this.componentCode
      );
      return metalData.imagePath;
    },
    //得到使用者動態輸入的值
    customTextTempleName() {
      return this.$store.getters.getCutomTempleName;
    },
    customTextGodName() {
      return this.$store.getters.getCutomGodName;
    },
    customTextGift() {
      return this.$store.getters.getCutomGift;
    },
    customTextRespect() {
      return this.$store.getters.getCutomRespect;
    },
    verticalTextInfo() {
      // 為了給 vertical 相關計算 method 使用
      // 目前僅用到 godName
      if (this.useGodNameVerticalText) {
        return this.textInfo.filter((item) => item.name === "godName");
      } else {
        return [];
      }
    },
  },
  methods: {
    controlWrapMethod() {
      return this.useNotReverse ? this.controlWrapNotReverse : this.controlWrap;
    },
    handleGodName() {
      if (this.useGodNameVerticalText) {
        const godNameIndex = 0; // verticalTextInfo 中 godName 的 index 永遠是 0
        this.verticalControlWrap(godNameIndex, this.customTextGodName);
        this.verticalControlFontsize(godNameIndex, this.customTextGodName);
      } else {
        this.controlWrapMethod()(1, this.customTextGodName);
        this.controlFontsize(1, this.customTextGodName);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.metal_changed_pic {
  position: relative;
  font-family: "Noto Serif TC";
  img {
    width: 100%;
  }
  .metal-text {
    position: absolute;
    color: $primaryLightColor;
    font-weight: 800;
    @include betweenTableTablePro {
      transform: scale(0.8);
    }
    @include table {
      transform: scale(0.7);
    }
    @include phone {
      transform: scale(0.64);
    }
  }
}
.templeName {
  border: 1px dashed $primaryLightColor;
  margin: 0 auto;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  .textContainer {
    span {
      white-space: nowrap;
    }
  }
}
.godName {
  margin: 0 auto;
  border: 1px dashed $primaryLightColor;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  .textContainer {
    span {
      white-space: nowrap;
    }
  }
}
.gift {
  margin: 0 auto;
  border: 1px dashed $primaryLightColor;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  .textContainer {
    span {
      white-space: nowrap;
    }
  }
}
.respect {
  width: 46px;
  margin: 0 auto;
  box-sizing: border-box;
  .textContainer {
    width: 46px;
  }
}
</style>
